import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {NgClass} from '@angular/common';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-slide-toggle-padrao',
  standalone: true,
  imports: [
    MatSlideToggle,
    NgClass,
    FormsModule
  ],
  templateUrl: './slide-toggle-padrao.component.html',
  styleUrl: './slide-toggle-padrao.component.css'
})
export class SlideTogglePadraoComponent {
  @Input() labelTrue = 'Ativo';
  @Input() labelFalse = 'Inativo';

  @Input() fontSize = '12px';
  @Input() disabled = false;

  @Input() invertido = false;

  @Input() carregandoInfo?: boolean = false;

  @Input() valor?: boolean;
  @Output() changeValue = new EventEmitter();

  change() { this.changeValue.emit(this.valor); }
}
